export default "__VITE_ASSET__DbF71zrE__"